import { EVENT_NAMES } from './messaging-events';
import { EXTERNAL_SCOPE_TYPES } from '../models/messaging-user';
import { MODEL_NAMES } from '../constants/index';
import Service, { service } from '@ember/service';

export default class ClientProfileNavigatorService extends Service {
  @service messagingEvents;
  @service store;

  canNavigateToClientProfile(filteredUsers, isClinician) {
    const participantsAreClients = filteredUsers.every(
      user => user.externalScope === EXTERNAL_SCOPE_TYPES.client
    );

    return participantsAreClients && isClinician;
  }

  async navigateToClientProfile(conversation, filteredUsers) {
    const navigationData = await this.getNavigationDataFromConversation(
      conversation,
      filteredUsers
    );

    this.messagingEvents.emit(EVENT_NAMES.openClientProfile, navigationData);
  }

  async getNavigationDataFromConversation(conversation, filteredUsers) {
    // Handle Couple conversation case
    if (conversation.linkExternalId) {
      return {
        externalId: conversation.linkExternalId,
        isParentId: false,
      };
    }

    // Handle Contact vs Client conversation case
    const externalId = filteredUsers[0]?.externalId;
    const contact = await this.store.adapterFor(MODEL_NAMES.CONTACT).fetchContact(externalId);

    return {
      externalId: contact?.parentExternalId || externalId,
      isParentId: !!contact?.parentExternalId,
    };
  }
}
